<ion-segment
  #segmentPills
  mode="ios"
  [value]="newValue"
  [scrollable]="true"
  [ngStyle]="{ '--background': 'var(--ion-color-' + colorSegment + ')' }"
  (ionChange)="onSegmentChange($event)"
  class="filter-pill-segment"
  [ngClass]="{ 'scroll-segment': isDesktop }"
>
  <ng-container *ngFor="let item of segments; let i = index">
    <ion-segment-button
      [value]="item.id"
      layout="icon-start"
      class="filter-pill-button"
      (click)="onPill(i)"
      [ngStyle]="{
        'border-color': item.color
          ? 'var(--ion-color-' + item.color + ')'
          : 'var(--ion-color-getm-primary-default)',
        '--color': item.color
          ? 'var(--ion-color-' + item.color + ')'
          : 'var(--ion-color-getm-primary-default)',
        '--indicator-color': item.color
          ? 'var(--ion-color-' + item.color + ')'
          : 'var(--ion-color-getm-primary-default)',
        '--background-checked':
          newValue === item.id
            ? 'var(--ion-color-' + item.color + ')'
            : 'var(--ion-color-getm-neutral-white)'
      }"
    >
      <ng-container *ngIf="item.icon">
        <ion-icon [name]="item.icon" class="filter-pill-icon"> </ion-icon>
      </ng-container>

      <ion-label>
        {{ item.title }}
      </ion-label>
    </ion-segment-button>
  </ng-container>
</ion-segment>
